import { ListItemButton, type ListItemButtonProps, styled } from "@mui/material";

type StyledSideBarButtonProps = ListItemButtonProps & {
  hasborder: string;
};

export const StyledSideBarButton: React.ComponentType<StyledSideBarButtonProps> = styled(
  ListItemButton,
)<StyledSideBarButtonProps>(({ theme, hasborder }) => ({
  paddingLeft: theme.spacing(3),
  position: "relative",
  borderTop: hasborder === "true" ? "1px solid" : "none",
  borderColor: theme.palette.divider,

  "& .MuiListItemText-root": {
    marginLeft: "10px",
    color: theme.palette.primary.main,
    marginTop: "0px",
    marginBottom: "0px",

    "& .MuiListItemText-primary": {
      lineHeight: 1.57,
    },
  },
  "& .MuiListItemIcon-root": {
    color: theme.palette.primary.main,
    svg: {
      width: "16px",
      height: "16px",
    },
  },
  ":hover": {
    background: theme.palette.grey[100],
  },
  "&.Mui-selected": {
    background: theme.palette.grey[100],
    ":before": {
      content: '""',
      left: "0",
      position: "absolute",
      width: "5px",
      height: "100%",
      backgroundColor: theme.palette.secondary.main,
    },
    ":hover": {
      background: theme.palette.grey[100],
    },
    "& .MuiListItemText-root": {
      "& .MuiListItemText-primary": {
        fontWeight: theme.typography.fontWeightSemiBold,
      },
    },
    "& .MuiListItemIcon-root": {
      color: theme.palette.primary.main,
      svg: {
        width: "16px",
        height: "16px",
      },
    },
  },
}));
